import React from 'react'

const ReportedEventsAccordion = (props:any) => {
    React.useEffect(()=>{
        console.log(props.data[0].details, ' props');
    },[]);
    return (
        <>
            <div style={{width:'100%', height:'100px'}}>
                Reported Events
            </div>
        </>
    )
}

export default ReportedEventsAccordion
